<main
  class="container-fluid bg-secondary bg-center  d-flex align-items-center justify-content-center"
  style="height: 100dvh;">
  <div
    class="col-12 col-md-7 col-lg-4 col-xl-4 col-xxl-3 bg-white-semi-transparent rounded-3">
    <router-outlet></router-outlet>
  </div>
</main>
